export default "__VITE_ASSET__DSxbhJlW__"